import * as THREE from 'three';
import { CORE_BOARD_STRIKE_TARGET } from './coreBoardLayout';
import { getCoreSpellProgress } from './coreBoardPhases';

// Shares the board's renderer and disposal lifecycle; no extra WebGL context.
export const createCoreBoardSpellScene = (scene) => {
  const group = new THREE.Group();
  group.visible = false;
  scene.add(group);
  const material = new THREE.MeshBasicMaterial({
    color: 0xce65ff,
    transparent: true,
    opacity: 0.9,
    blending: THREE.AdditiveBlending,
    depthWrite: false,
    toneMapped: false,
  });
  const beam = new THREE.Mesh(
    new THREE.CylinderGeometry(0.07, 0.19, 1, 8),
    material
  );
  const halo = new THREE.Mesh(
    new THREE.CylinderGeometry(0.2, 0.5, 1, 8),
    material.clone()
  );
  halo.material.opacity = 0.24;
  const impact = new THREE.Mesh(
    new THREE.TorusGeometry(0.7, 0.06, 6, 32),
    material.clone()
  );
  impact.rotation.x = -Math.PI / 2;
  group.add(beam, halo, impact);
  const target = new THREE.Vector3();
  const direction = new THREE.Vector3();
  const axis = new THREE.Vector3(0, 1, 0);
  const tilePoint = (index) =>
    new THREE.Vector3(
      ((index % 5) - 2) * 2.85,
      -1.1,
      (Math.floor(index / 5) - 2) * 2.85
    );
  const update = (spell, reduceMotion) => {
    const p = spell ? getCoreSpellProgress(spell) : 0;
    group.visible =
      !!spell &&
      !reduceMotion &&
      p >= 0.35 &&
      p < 0.96 &&
      spell.changes.length > 0;
    if (!group.visible) return;
    const sweep = THREE.MathUtils.clamp((p - 0.4) / 0.45, 0, 1);
    const row = spell.spells.length === 1 ? spell.spells[0].row : null;
    if (row !== null) {
      target.set(-5.7 + sweep * 11.4, -1.1, (row - 2) * 2.85);
    } else {
      const cursor = sweep * Math.max(0, spell.changes.length - 1);
      const first = Math.floor(cursor);
      const last = Math.min(first + 1, spell.changes.length - 1);
      target
        .copy(tilePoint(spell.changes[first].index))
        .lerp(tilePoint(spell.changes[last].index), cursor - first);
    }
    direction.copy(target).sub(CORE_BOARD_STRIKE_TARGET);
    beam.position.copy(CORE_BOARD_STRIKE_TARGET).lerp(target, 0.5);
    beam.scale.y = direction.length();
    beam.quaternion.setFromUnitVectors(axis, direction.normalize());
    halo.position.copy(beam.position);
    halo.scale.copy(beam.scale);
    halo.quaternion.copy(beam.quaternion);
    impact.position.copy(target);
    impact.scale.setScalar(0.8 + Math.sin(p * 70) * 0.1);
    material.opacity = p > 0.85 ? Math.max(0, (0.96 - p) / 0.11) : 0.9;
  };
  return { update, group, beam, impact };
};
